import { BaseAllocationRulesViewStore } from '@yard/pages/YardSetup/stores/allocation-rules/base-allocation-rules.view-store'
import { YardViewStore } from '@yard/pages/YardSetup/stores/yard.view-store'
import { observer } from 'mobx-react-lite'
import { AllocationRuleDialogCreate } from './AllocationRuleDialogCreate'
import { AllocationRuleDialogImport } from './AllocationRuleDialogImport'

interface Props {
  yardViewStore: YardViewStore
  allocationRulesViewStore: BaseAllocationRulesViewStore
}
export const AllocationRulesDialogs = observer((props: Props) => {
  const { allocationRulesViewStore, yardViewStore } = props
  return (
    <>
      <AllocationRuleDialogImport
        allocationRulesViewStore={allocationRulesViewStore}
        yardBlocks={yardViewStore.yardBlocks}
      />
      <AllocationRuleDialogCreate {...props} />
    </>
  )
})
